<template>
  <div class="layout-desktop">
    <asta-drawer-standalone v-if="Config.STANDALONE"></asta-drawer-standalone>
    <asta-drawer v-else></asta-drawer>
    <asta-nav></asta-nav>
    <v-main>
      <v-row no-gutters>
        <!-- svincolati -->
        <v-col cols="3">
          <div class="asta-svincolati-desktop">
            <asta-svincolati showTitle></asta-svincolati>
          </div>
        </v-col>
        <v-col cols="6" class="desktop-central">
          <!-- tavolo  -->
          <div class="asta-tavolo-desktop">
            <asta-tavolo></asta-tavolo>
          </div>
          <!-- chat -->
          <div class="asta-chat-messages-desktop">
            <asta-chat-messages></asta-chat-messages>
          </div>
          <div class="asta-chat-input-desktop">
            <asta-chat-input></asta-chat-input>
          </div>
        </v-col>
        <!-- rose -->
        <v-col cols="3">
          <div class="asta-rose-desktop">
            <asta-rose showTitle v-show="(planOrRose == 'rose')"></asta-rose>
            <asta-plan
              v-if="my_squadra"
              showTitle
              v-show="(planOrRose == 'plan')"
            ></asta-plan>
          </div>
        </v-col>
      </v-row>
    </v-main>
    <!-- footer -->
    <asta-footer fixed></asta-footer>
  </div>
</template>

<script>
// import Config from "../../../config-app/config";
import AstaNav from "../AstaNav.vue";
import AstaTavolo from "../AstaTavolo.vue";
import AstaDrawer from "../AstaDrawer";
import AstaDrawerStandalone from "../AstaDrawerStandalone";
import AstaSvincolati from "../AstaSvincolati";
import AstaRose from "../AstaRose";
import AstaChatMessages from "../AstaChatMessages";
import AstaChatInput from "../AstaChatInput";
import AstaPlan from "../AstaPlan";
import AstaFooter from "../AstaFooter";
import Vuex from "vuex";
import mixins from "../../js/mixins";
import Constants from "../../js/constants";

export default {
  name: "asta-desktop",
  mixins: [mixins],
  components: {
    AstaNav,
    AstaTavolo,
    AstaSvincolati,
    AstaRose,
    AstaChatMessages,
    AstaChatInput,
    AstaPlan,
    AstaDrawer,
    AstaDrawerStandalone,
    AstaFooter,
  },
  data() {
    return {
      // value: Constants.ASTA_TABS.MAIN,
      // Config: Config
    };
  },

  methods: {
    // selectTab: function (idx) {
    //   this.$store.dispatch("selectTab", idx);
    // },
  },
  mounted() {
    console.log("--> AstaDesktop ready.");
  },
  destroyed() {
    console.log("<-- AstaDesktop destroyed.");
  },
  computed: {
    ...Vuex.mapGetters(["planOrRose"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.desktop-central {
  position: relative;
  // box-shadow: 0px 0px 22px 10px rgba(0, 0, 0, 0.2);
  .asta-tavolo-desktop {
    position: absolute;
    right: 0;
    top: 0px;
    left: 0;
    // bottom: 70%;
  }
  .asta-chat-messages-desktop {
    position: absolute;
    top: 30%; // serve per evitare che l'user tenti di scrollare sui messaggi che nn scrollerebbero
    bottom: 0;
    left: 0;
    right: 0;
    .chat {
      padding-bottom: 75px;
    }
  }
  .asta-chat-input-desktop {
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
  }
}

.v-main {
  height: 100vh;
  // background-image: url(/static/img/bg-seamless.png);
  // background-repeat: repeat;
  // background-color: white;
  background-color: var(--v-navy-darken1);
  background-image: linear-gradient(
    0deg,
    var(--v-navy-darken2),
    var(--v-navy-darken1) 300px
  );
}
</style>
